module.exports = __webpack_public_path__ + "static/media/google-play-de.235818b9.png";